import store from "./index";
export default {
  SET_ERROR(state, data) {
    state.error = true;
    state.errorMessage = {
      type: "Error",
      message: data.message,
    };
  },
  SET_INFO(state, data) {
    state.error = true;
    state.errorMessage = {
      type: "info",
      message: data,
    };
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
  DISMISS_ERROR(state) {
    state.error = false;
  },
  //! Setting values on Loggig IN
  SET_LOGIN: (state, res) => {
    store._vm.$session.set("token", res.token);
    store._vm.$session.set("isLoggedIn", true);
    store._vm.$session.set("uid", res.userInfo.id);
    store._vm.$session.set("name", res.userInfo.name);
    store._vm.$session.set("userinfo", res.userInfo);
    store._vm.$session.set("company", res.company);
    state.token = res.token;
    state.uid = res.uid;
    state.path = "/DASHBOARD";
  },
  UNSET_LOGIN: (state) => {
    store._vm.$session.destroy();
    state.path = "/";
    state.token = "";
  },
  SET_PRODUCTS(state, data) {
    state.products = data;
  },
  SET_CATEGORY(state, data) {
    state.category = data;
  },
  SET_VENDORS(state, data) {
    state.vendors = data;
  },
  SET_STOCKROOM(state, data) {
    state.stockroom = data;
  },
  // SET_SHOP_DATA(state, data) {
  //   state.shopdata = data;
  // },
  SET_BILL_STOCK(state, data) {
    state.billstock = data;
  },
  SET_BILLS(state, data) {
    state.allBills = data;
  },
  SET_PRINT_BILLS(state, data) {
    state.billItems = data;
  },
  SET_PRODUCTS_LIST_VENDOR(state, data) {
    state.vendorProdList = data;
  },
  SET_MRPS_STOCK(state, data) {
    state.stockdata = data;
  },

  SET_ONLINE_CATEGORY(state, data) {
    state.onlineCat = data;
  },
  SET_ONLINE_PRODUCTS(state, data) {
    state.onlineProd = data;
  },
  SET_ONLINE_ORDER_ITEMS(state, data) {
    state.onlineOrdersItems = data;
  },
  SET_ONLINE_ORDER(state, data) {
    state.onlineOrders = data;
  },
};
